<template>
  <div class="my-3 mx-5">
    <div class="formula-editor">
      <math-field ref="mathField" :model-value="latexValue" @input="handleMathInput">{{ latexValue}}</math-field>
    </div>

    <select class="form-select mt-4" v-model="selectedProfitId" @change="handleProfitChange">
      <option v-for="item in profits" :value="item.id" :key="item.id">
        {{ item.title }}
      </option>
    </select>

    <div class="mt-3">
      <SmartFormula
          v-if="latexValue"
          :formula="latexValue"
          :variables="profits"
      />
    </div>
  </div>
</template>

<script>
import SmartFormula
  from "@/components/Financial_management_and_productivity/DefineProductivityRepresentations/SmartFormula.vue";

export default {
  components: {SmartFormula},
  props: {
    latexValue: {
      type: String,
      default: ''
    },
    profits: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:latexValue'],
  data() {
    return {
      selectedProfitId: null
    }
  },
  methods: {
    handleMathInput(event) {
      this.$emit('update:latexValue', event.target.value);
    },
    handleProfitChange() {
      if (!this.selectedProfitId) return;

      const newValue = `${this.latexValue ?? ''}(profitId${this.selectedProfitId})`;
      this.$refs.mathField.value = newValue;
      this.$emit('update:latexValue', newValue);
      this.selectedProfitId = null;
    }
  }
};
</script>

<style scoped>
math-field {
  width: 100%;
  direction: ltr;
  padding: 0.5rem;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
}

.form-select {
  width: 50%;
  margin: 0 auto;
  transition: border-color 0.15s ease-in-out;
}

.form-select:focus {
  border-color: #86b7fe;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
</style>